import { Link } from "react-router-dom";
import styles from "./LinkElement.module.css";

function LinkElement({ title = "Не задано", link = "Не задано" }) {
  return (
    <Link className={styles.wrapper} to={link}>
      {title}
    </Link>
  );
}

export default LinkElement;
